"use strict";var e=require("react");module.exports=(t,r,n)=>{e.useEffect((()=>{function e(e){if(t.current&&!t.current.contains(e.target))return r(e)}return document.addEventListener("mousedown",e,n?null:{capture:!0}),()=>{document.removeEventListener("mousedown",e)}}),[t,r])};
//# sourceMappingURL=index.js.map
